import React, { useCallback, useEffect, useState } from 'react';

// Bottom-right transient notice used across the Communications surfaces.
// `useToast()` returns [toast, setToast]; render `<Toast toast={toast} />`.
// Shape: { message, detail?, action?: { label, onClick }, ms? }. Auto-dismisses
// after `ms` (default 4s; pass a longer one when offering Undo).
export function useToast(defaultMs = 4000) {
  const [toast, setToastState] = useState(null);
  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(() => setToastState(null), toast.ms || defaultMs);
    return () => clearTimeout(t);
  }, [toast, defaultMs]);
  const setToast = useCallback((t) => setToastState(t ? { ...t, key: Date.now() } : null), []);
  return [toast, setToast];
}

export default function Toast({ toast, onDismiss }) {
  if (!toast) return null;
  return (
    <div role="status" className="fixed bottom-4 right-4 z-[120] max-w-sm rounded-xl border border-[#B0FC38]/20 bg-[#0a0a0f]/95 backdrop-blur-md p-3 shadow-[0_10px_40px_-10px_rgba(0,0,0,0.9)]">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[13px] text-white">{toast.message}</div>
          {toast.detail && <div className="text-[11px] text-gray-500 mt-1">{toast.detail}</div>}
        </div>
        {toast.action && (
          <button
            type="button"
            onClick={() => { toast.action.onClick?.(); onDismiss?.(); }}
            className="shrink-0 text-[12px] text-[#B0FC38] hover:underline underline-offset-2"
          >
            {toast.action.label}
          </button>
        )}
      </div>
    </div>
  );
}
